import { parseQueryParamsObject } from "@robe/core-utils";
import { SubCategory } from "@robe/core-types/category";
import { Content } from "@robe/core-types/content";
import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { fillMissingLocalizedCategoriesNames } from "./utils";

export enum IncludeRelations {
  Minimal = 1,
  Full = 2,
}

export interface GetSubCategoriesOptions<TContent extends Content | never = never> {
  includeContents?: boolean;
  includeRelations?: IncludeRelations;
  includeValues?: boolean;
  contentFields?: (keyof TContent["values"])[];
}

export const getSubCategoriesByTopLevelCategory = <TContent extends Content | never = never>(
  topLevelCategory: string,
  core: XcoreCore,
  options?: GetSubCategoriesOptions<TContent>
): BaseApiRequest<SubCategory[]> =>
    core
      .fetch(
        `/api/category/subcategory${parseQueryParamsObject({
          topLevelCategory,
          ...(options?.includeContents && { includeContents: true }),
          ...(options?.includeRelations && { includeRelations: options.includeRelations }),
          ...(options?.includeValues && {
            includeValues: true,
            includeContents: true,
          }),
          ...(options?.contentFields && {
            includeValues: true,
            fields: options.contentFields,
            includeContents: true,
          }),
        })}`
      )
      .then((res) => res.json())
      .then(fillMissingLocalizedCategoriesNames);
